import cacheConfig from '../../config/cache.config';

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client) {
    return;
  }

  // live-preview pages keep the no-store header from routeRules
  if (to.path.includes('/preview/')) {
    return;
  }

  const header = useResponseHeader('Cache-Control');
  type CacheControlKey = keyof typeof cacheConfig.headers.cacheControl;
  const name = to.meta.pageType || (to.name || '')?.split('___')[0] as CacheControlKey | undefined;
  const maxAge = name && cacheConfig.headers.cacheControl[name] !== undefined
    ? cacheConfig.headers.cacheControl[name]
    : cacheConfig.headers.cacheControl.default;
  header.value = `public, max-age=${maxAge}, s-maxage=${maxAge}, stale-while-revalidate=60, stale-if-error=7200`;
});
